// extracted by mini-css-extract-plugin
export default {"v-hackster":"var(--hackster)","v-staticWhite":"var(--staticWhite)","hasLinks":"video_info__hasLinks__J2uB3","hasLinksWhite":"video_info__hasLinksWhite___Va7c"};